import {
  GET_USERS_LIST_BY_TYPE,
  REGISTER_USERS_BY_TYPE,
  UPDATE_STATUS,
  UPDATE_STATUS_COGNITO,
  VERIFY_USERS,
  USER_ERROR,
  USER_SUCCESS,
  UPDATE_USER,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAIL
} from "./actionTypes";

export const registerUsersByType = users => {
  return {
    type: REGISTER_USERS_BY_TYPE,
    payload: users,
  }
}

export const getUserListByType = data => {
  return {
    type: GET_USERS_LIST_BY_TYPE,
    payload: { data }
  }
}

export const updateStatus = data => {
  return {
    type: UPDATE_STATUS,
    payload: { data }
  }
}
export const updateStatusCognito = data => {
  return {
    type: UPDATE_STATUS_COGNITO,
    payload: { data }
  }
}

export const verifyUser = list => {
  return {
    type: VERIFY_USERS,
    payload: { list }
  }
}

export const userSuccess = data => {
  return {
    type: USER_SUCCESS,
    payload: data
  }
}

export const userError = data => {
  return {
    type: USER_ERROR,
    payload: { data }
  }
}

export const updateUsers = data => ({
  type: UPDATE_USER,
  payload: data,
})

export const updateUsersSuccess = user => ({
  type: UPDATE_USER_SUCCESS,
  payload: user,
})

export const updateUsersFail = error => ({
  type: UPDATE_USER_FAIL,
  payload: error,
})